<template>
    <div class="form">
        <div class="pt-3">
            <h5 class="text-center"><b>SECTION II</b></h5>
            <h5 class="text-center"><b>GENERAL COMMENTS ON STAFF MEMBER'S PERFORMANCE</b></h5>

            <div class="pe-0 me-2 mx-2 mt-4">
                <p class="mb-0">
                    <b>
                        A. &nbsp; &nbsp;Comments by Supervisor
                    </b>
                </p>
            </div>
            <div class="flex-fill mx-5 mb-3">
                <textarea v-model="hodComments" type="text" class="form-control pb-0" id="exampleInputEmail1"
                    aria-describedby="emailHelp" rows="2"></textarea>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-3">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>Supervisor Name:</b></p>
                </span>
                <span class="p-0">
                    <input type="text" class="form-control pb-0" name="name" v-model="hodName" style="width: 110%;">
                </span>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-5">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>Date:</b></p>
                </span>
                <span class="p-0">
                    {{ hodDate }}
                </span>
            </div>

            <div class="pe-0 mx-2">
                <p class="mb-0">
                    <b>
                        B. &nbsp; &nbsp;Overall Assessment by Head of Department
                    </b>
                </p>
            </div>
            <div class="flex-fill mx-5 mb-3">
                <textarea v-model="deanComments" type="text" class="form-control pb-0" id="exampleInputEmail1"
                    aria-describedby="emailHelp" rows="2"></textarea>
            </div>
            <div class="text-start mx-5 mb-3">
                <div class="mb-1">Has any adverse comments been brought to the attention of the staff?</div>
                <div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio46" value='Yes'
                            v-model="adverseComments">
                        <label class="form-check-label" for="inlineRadio46">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio47" value='No'
                            v-model="adverseComments">
                        <label class="form-check-label" for="inlineRadio47">No</label>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-wrap mb-3 mx-5">
                <span class="pe-0 me-2">
                    <p class="mb-0"><b>Head of Department Name:</b></p>
                </span>
                <span class="p-0">
                    <input type="text" class="form-control pb-0" name="name" v-model="deanName" style="width: 125%;">
                </span>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-5">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>Date:</b></p>
                </span>
                <span class="p-0">
                    {{ deanDate }}
                </span>
            </div>

            <div class="pe-0 me-2 ms-2 mb-2">
                <p class="mb-0">
                    <b>
                        C. &nbsp; &nbsp;Findings and Recommendations of Appraisal Panel
                    </b>
                </p>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-2">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>(i) &nbsp; Total Score:</b> &nbsp; {{ score }}</p>
                </span>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-2">
                <span class="pe-0 me-2 mx-4">
                    <p class="mb-0"><b>(ii) &nbsp; Remarks:</b></p>
                </span>
                <span class="p-0">
                    <input type="text" class="form-control pb-0" name="remarks" v-model="remarks" style="width: 125%;">
                </span>
            </div>
            <div class="mx-4 mb-2">
                <div class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>(iii) &nbsp; Recommendations:</b></p>
                </div>
                <div class="flex-fill mx-5 mb-3">
                    <textarea v-model="recommendations" type="text" class="form-control pb-0" id="exampleInputEmail1"
                        aria-describedby="emailHelp" rows="2"></textarea>
                </div>
            </div>
            <div class="d-flex flex-wrap mx-4 mb-3">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>Name (Chairman of Appraisal Panel)</b></p>
                </span>
                <span class="p-0">
                    <input type="text" class="form-control pb-0" name="name" v-model="chairmanName" style="width: 150%;">
                </span>
            </div>
            <div class="d-flex flex-wrap mx-4">
                <span class="pe-0 me-2 ms-4">
                    <p class="mb-0"><b>Date:</b></p>
                </span>
                <span class="p-0">
                    {{ chairmanDate }}
                </span>
            </div>


            <div class="text-start p-5 container">
                <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
                <button @click="saveSection('save')" type="button" class="btn btn-success">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'nonacademicAssessorSection2',
    emits: ['toggleLoader'],
    data() {
        return {
            hodComments: '',
            hodName: '',
            deanComments: '',
            adverseComments: 'No',
            deanName: '',
            score: 0,
            remarks: '',
            recommendations: '',
            chairmanName: '',
            hodDate: '',
            deanDate: '',
            chairmanDate: ''
        }
    },
    computed: {
        hodComputedDate(){
            const date = new Date();
            return date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear()
        },
        deanComputedDate(){
            const date = new Date();
            return date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear()
        },
        chairmanComputedDate(){
            const date = new Date();
            return date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear()
        }
    },
    created() {
        this.setData()
    },
    methods: {
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                hodComments: {
                    name: this.hodName,
                    comment: this.hodComments,
                    date: this.hodDate
                },
                deanComments: {
                    name: this.deanName,
                    comment: this.deanComments,
                    date: this.deanDate
                },
                adverseComments: this.adverseComments,
                chairmanComments: {
                    remarks: this.remarks,
                    recommendations: this.recommendations,
                    name: this.chairmanName,
                    date: this.chairmanDate
                }
            }

            const candidate = await DataService.saveData(dataDetails);

            this.$emit('toggleLoader');

            if (candidate) {
                if (page == 'previous') {
                    this.$router.push("/nonacademicassessorsection1")
                } else {
                    alert('Comments have been saved successfully')
                }
            }
        },
        async setData() {
            this.$emit('toggleLoader');

            window.scrollTo({ top: 0, behavior: 'smooth' });

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id)
            
            if (candidate) {
                this.hodComments = candidate.hodComments ? candidate.hodComments.comment : '';
                this.hodName = candidate.hodComments ? candidate.hodComments.name : '';
                this.hodDate = candidate.hodComments ? candidate.hodComments.date : this.hodComputedDate;
                this.deanComments = candidate.deanComments ? candidate.deanComments.comment : '';
                this.deanName = candidate.deanComments ? candidate.deanComments.name : '';
                this.deanDate = candidate.deanComments ? candidate.deanComments.date : this.deanComputedDate;
                this.score = candidate.overall ? candidate.overall : 0;
                this.adverseComments = candidate.adverseComments ? candidate.adverseComments : 'No';
                this.remarks = candidate.chairmanComments ? candidate.chairmanComments.remarks : '';
                this.recommendations = candidate.chairmanComments ? candidate.chairmanComments.recommendations : '';
                this.chairmanName = candidate.chairmanComments ? candidate.chairmanComments.name : '';
                this.chairmanDate = candidate.chairmanComments ? candidate.chairmanComments.date : this.chairmanComputedDate;
            }
            
            this.$emit('toggleLoader');
        }
    }
}
</script>